// Données statiques pour le site Sax&DJ
// Pour modifier vos contenus, éditez simplement ce fichier !

export const services = [
  {
    id: 1,
    title: "Sax + DJ",
    subtitle: "Formule Premium",
    description: "L'alliance parfaite entre l'élégance du saxophone et l'ambiance du DJ pour une soirée inoubliable",
    features: [
      "Accompagnement musical de la cérémonie",
      "Saxophone live pendant le cocktail",
      "Animation DJ pour la soirée dansante", 
      "Matériel son et éclairage professionnel",
      "Interaction avec les invités",
      "Playlist personnalisée"
    ],
    highlight: true
  },
  {
    id: 2,
    title: "DJ Soirée",
    subtitle: "Animation Dansante",
    description: "DJ généraliste pour mariages avec une spécialisation dans l'électronique pour une soirée mémorable",
    features: [
      "DJ généraliste",
      "Spécialisé BigRoom, Trance, EDM",
      "Adaptation à tous styles musicaux",
      "Matériel son et éclairage professionnel",
      "Demandes musicales en direct"
    ]
  },
  {
    id: 3,
    title: "Saxophone Cocktail",
    subtitle: "Ambiance Live",
    description: "Créez une atmosphère raffinée avec le saxophone pour votre cocktail",
    features: [
      "Répertoire jazz, lounge, pop et electro",
      "Performance de 1h à 2h",
      "Ambiance musicale adaptée",
      "Matériel son inclus"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie & Thomas",
    date: "Août 2024",
    event: "Mariage au Château de Versailles",
    comment: "Prestations exceptionnelles ! Le saxophone pendant le cocktail a créé une ambiance magique, et la soirée DJ était parfaite. Tous nos invités ont dansé jusqu'au bout de la nuit.",
    rating: 5
  },
  {
    id: 2,
    name: "Sophie & Alexandre",
    date: "Juin 2024", 
    event: "Mariage en Provence",
    comment: "Un duo fantastique ! La transition entre le saxophone et le DJ s'est faite naturellement. L'artiste a su s'adapter à nos goûts musicaux et créer l'ambiance que nous souhaitions.",
    rating: 5
  },
  {
    id: 3,
    name: "Camille & Julien",
    date: "Septembre 2024",
    event: "Mariage au Domaine de Chantilly",
    comment: "Professionnel, à l'écoute et très talentueux. La cérémonie laïque accompagnée au saxophone nous a donné des frissons. Nous recommandons vivement !",
    rating: 5
  },
  {
    id: 4,
    name: "Émilie & Pierre",
    date: "Mai 2024",
    event: "Mariage au Château de Fontainebleau",
    comment: "Une prestation de qualité exceptionnelle ! Le saxophone a apporté une touche d'élégance unique à notre cocktail. La soirée DJ a fait danser tous nos invités.",
    rating: 5
  }
];

// Portfolio avec vos vraies images hébergées sur Hostinger
export const portfolioItems = [
  // Photo Hero - Page d'accueil
  {
    id: 'hero-1',
    title: "Photo Titre Homepage",
    description: "Votre photo principale",
    category: "hero-accueil",
    image_url: "/images/hero-accueil_001.webp",
    is_active: true
  },
  
  // Cérémonies
  {
    id: 'cer-1',
    title: "Cérémonie Laïque",
    description: "Accompagnement musical personnalisé",
    category: "ceremonie",
    image_url: "/images/ceremonie_001.webp",
    is_active: true
  },
  
  // Cocktails
  {
    id: 'coc-1',
    title: "Cocktail Saxophone",
    description: "Ambiance raffinée en extérieur",
    category: "cocktail",
    image_url: "/images/cocktail_001.webp",
    is_active: true
  },
  {
    id: 'coc-2',
    title: "Cocktail Jazz",
    description: "Répertoire jazz et lounge",
    category: "cocktail",
    image_url: "/images/cocktail_002.webp",
    is_active: true
  },
  
  // Soirées
  {
    id: 'soi-1',
    title: "Soirée Dansante",
    description: "Animation DJ avec éclairage",
    category: "soiree",
    image_url: "/images/soiree_001.webp",
    is_active: true
  },
  {
    id: 'soi-2',
    title: "Ambiance Soirée",
    description: "Moment festif",
    category: "soiree",
    image_url: "/images/soiree_002.webp",
    is_active: true
  },
  
  // Sax + DJ
  {
    id: 'sax-1',
    title: "Performance Sax + DJ",
    description: "Moment d'exception en soirée",
    category: "sax-dj",
    image_url: "/images/sax-dj_001.webp",
    is_active: true
  },
  {
    id: 'sax-2',
    title: "Duo Sax & DJ",
    description: "L'alliance parfaite",
    category: "sax-dj",
    image_url: "/images/sax-dj_002.webp",
    is_active: true
  },
  
  // Photo de profil - Page À propos
  {
    id: 'profile-1',
    title: "Photo de Profil",
    description: "Votre photo professionnelle",
    category: "about-profile",
    image_url: "/images/about-profile_001.webp",
    is_active: true
  }
];

// Pour compatibilité avec l'ancien code
export const portfolioPlaceholders = portfolioItems.filter(item => 
  !['hero-accueil', 'about-profile'].includes(item.category)
);

export const aboutInfo = {
  title: "Passionné de musique et d'événements",
  description: "Avec plus de 10 ans d'expérience dans l'animation musicale, je mets mon savoir-faire au service de vos moments les plus précieux. Saxophoniste professionnel et DJ expérimenté, j'accompagne vos mariages et événements privés avec passion et créativité.",
  expertise: [
    "Saxophoniste depuis l'âge de 6 ans",
    "DJ spécialisé événementiel",
    "Plus de 50 mariages premium accompagnés",
    "Matériel professionnel de qualité",
    "Approche personnalisée pour chaque événement"
  ]
};

// Informations de contact
export const contactInfo = {
  phone: "06.61.94.42.26",
  email: "contact@sax-dj.fr",
  location: "Île-de-France & régions"
};
